import React from 'react'

import classes from './PaginationButton.module.css'

const MPaginationButton = (props) => (<div style={{ display: 'inline-flex', alignItems: 'center', width: '7vw', height: '4vh', margin: '0 1vw' }} {...props} >
    <div style={{ position: "relative", width: '100%', height: '100%', marginTop: '-1vh' }}>
        <div className={classes.ParentDiv} />
        <div className={classes.BabyDiv}>{props.children}</div>
    </div>
</div>)

export default MPaginationButton